var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShieldLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.016 5.37a13.162 13.162 0 0 1-8.288-3.807l-.646-.645c-.985-.986-2.717-.986-3.668 0l-.646.645A13.162 13.162 0 0 1 2.48 5.37C1.12 5.472.068 6.627.068 7.953v3.806a23.4 23.4 0 0 0 11.89 20.358c.373.204.814.34 1.29.34.442 0 .883-.102 1.29-.34a23.4 23.4 0 0 0 11.89-20.358V7.987c0-1.36-1.053-2.515-2.412-2.617z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.955 20.562c0 .612-.51 1.122-1.121 1.122H8.662c-.611 0-1.12-.51-1.12-1.122v-6.22c0-.611.509-1.121 1.12-1.121h.883v-2.583a2.813 2.813 0 0 1 2.82-2.821h1.8a2.813 2.813 0 0 1 2.82 2.82v2.584h.883c.611 0 1.12.34 1.12.951v6.39h-.033z",
    fill: "#1BB814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.248 15.294a1.29 1.29 0 0 0-1.29 1.292c0 .407.203.781.509 1.02l-.34 1.325a.59.59 0 0 0 .102.475.53.53 0 0 0 .408.204h1.222c.17 0 .306-.068.408-.204.102-.136.136-.305.102-.475l-.34-1.326c.306-.238.51-.612.51-1.02a1.29 1.29 0 0 0-1.291-1.291zM14.165 9.856h-1.8a.805.805 0 0 0-.815.816v2.583h3.396v-2.583c0-.442-.34-.816-.78-.816z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShieldLock);
export default __webpack_public_path__ + "static/media/icon-shield-lock.19af9114923d158d661194121cf7a348.svg";
export { ForwardRef as ReactComponent };